export default `<p>Defi Lending Pool は、動的な段階別年率（APY）メカニズムを採用しています。資金効率を最大化するため、コントラクトには「日次レンジ上限決済」メカニズムが導入され、現在の収益は現在有効なルールに基づいて計算されます。システムは、保有する階層に対応する最高収益を自動的に適用します。</p>

<h2>1. 収益メカニズム</h2>
<p>ウォレットで承認を完了し、プラットフォームが合意に基づいて借入元本を送金すると、対応する借入記録が作成されます。各暦日に、プラットフォームは次のルールに基づいてその記録の収益を計算します：</p>
<ul>
  <li><strong>借入元本：</strong>その借入について送金され、記録された USDT 金額；</li>
  <li><strong>階層レート：</strong>その元本が属する範囲の日次収益率を照合し、範囲の最大値で決済；</li>
  <li><strong>日次収益：</strong>借入元本 × 実際の日次収益率 ÷ 100；</li>
  <li><strong>最新設定：</strong>管理画面で階層が調整された後、現在の利息は最新の有効なルールで再計算。</li>
</ul>
<p>プラットフォーム収益の出金は、出金可能残高と複利計算の基礎額にのみ影響し、<strong>オンチェーンのウォレット残高には影響しません</strong>。収益は<strong>1 日につき完全な日次収益率を 1 回</strong>適用して計算されます。管理画面に設定された複数の時点は当日の収益更新と表示にのみ使用され、日次収益を重複計算することはありません。収益はアカウントに累積され、「資産 → 決済注文」で詳細を確認できます。過去の収益は将来の成果を保証しません。</p>

<h2>2. 収益階層表</h2>
<p>以下の表は、<strong>Defi Lending Pool</strong> で現在有効な借入元本の階層と対応する日次収益率を示します。1 件あたりの貸出元本が大きいほど、より高い階層レートに該当します。表のレートはすべて<strong>日次パーセンテージ</strong>であり、年率 APY ではありません。</p>
<!-- YIELD_TIER_TABLE -->
<p><strong>説明：</strong>各借入は、その<strong>貸出元本</strong>に基づいて 1 つの階層に個別に照合されます。同じユーザーに複数の借入がある場合はそれぞれ計算し、その後に元本、利息、元利合計を集計して表示します。</p>

<h2>3. 階層照合ルール</h2>
<ul>
  <li>オンチェーン承認を完了し、実際の送金後に作成された借入記録が利息計算の対象になります；</li>
  <li>100 USDT 未満でも貸出できますが、実際の日次収益率は 0% です；</li>
  <li>各階層は 1 つの USDT 元本範囲に対応し、各借入は適用可能な 1 つの階層に自動で照合されます；</li>
  <li>階層がレート範囲で設定されている場合、決済にはその範囲の<strong>最大日次収益率</strong>が一律に適用されます；</li>
  <li>階層設定はプラットフォーム運営者が調整でき、変更は以後の決済にのみ適用され、過去の注文には影響しません。</li>
</ul>

<h2>4. 決済と表示</h2>
<h3>4.1 決済サイクル</h3>
<ul>
  <li><strong>利息計算頻度：</strong>承認済みの各資産に 1 日 1 回、完全な日次収益率を適用し、複数の表示時点で重複して利息を計算しません；</li>
  <li><strong>初回決済：</strong>当日に承認を完了したウォレットは、翌日から利息計算と決済が始まります；</li>
  <li><strong>注文項目：</strong>決済金額、通貨（USDT / USDC）、適用レート、決済時刻。</li>
</ul>
<h3>4.2 資産ページの指標</h3>
<p>「資産」ページでは、<strong>累計収益</strong>（過去の決済合計）と<strong>本日の収益</strong>（当日に決済済みの部分）を確認できます。データはシステムの注文記録を基準とします。</p>

<h2>5. Defi Lending Pool で収益を得る方法</h2>
<ol>
  <li>アカウントにログインし、互換性のある Web3 ウォレットを接続します；</li>
  <li>ウォレットで USDT の <strong>Approve（承認）</strong>トランザクションを確認します；</li>
  <li>プラットフォームが双方の合意に基づいて元本を送金すると、システムが借入記録を作成します；</li>
  <li>各元本は収益階層に自動で照合され、レート範囲は上限値で計算されます；</li>
  <li>「資産」ページで貸出中の元本、現在の利息、元利合計を確認します。</li>
</ol>

<h2>6. リスクに関する注意</h2>
<p><strong>Defi Lending Pool</strong> は非カストディアル方式を採用し、プラットフォームがユーザーの秘密鍵を保管することはありません。オンチェーン承認にはスマートコントラクトおよび市場のリスクがあり、階層レート、プール容量、決済結果は変動する可能性があります。参加前に「ルールとセキュリティ」ページをよくお読みください。</p>

<p>— 階層レートのデータはプラットフォームのバックエンド設定から同期されます。ページの表示は参考情報であり、最終的な決済金額は毎日の注文記録を基準とします。</p>`
